import { render, staticRenderFns } from "./VerkInvoiceHistory.vue?vue&type=template&id=50632e80&scoped=true&"
import script from "./VerkInvoiceHistory.vue?vue&type=script&lang=ts&"
export * from "./VerkInvoiceHistory.vue?vue&type=script&lang=ts&"
import style0 from "./VerkInvoiceHistory.vue?vue&type=style&index=0&id=50632e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50632e80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
